<!-- Loading State -->
@if (isLoading()) {
<div class="flex justify-center py-12">
	<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
</div>
} @else {
<!-- Staff Table -->
<div class="bg-white rounded-lg shadow overflow-hidden">
	<div class="overflow-x-auto">
	<table class="min-w-full divide-y divide-gray-200">
		<thead class="bg-gray-50">
			<tr>
				<th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
				<th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact</th>
				<th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
				<th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Working Hours</th>
				<th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
				<th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
			</tr>
		</thead>
		<tbody class="bg-white divide-y divide-gray-200">
			@for (staff of staffList(); track staff.id) {
			<tr class="hover:bg-gray-50">
				<td class="px-6 py-4 whitespace-nowrap">
					<div class="font-medium text-gray-900">{{ staff.first_name }} {{ staff.last_name }}</div>
				</td>
				<td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
					<div>{{ staff.email || '-' }}</div>
					<div>{{ staff.phone || '-' }}</div>
				</td>
				<td class="px-6 py-4 whitespace-nowrap">
					<span class="px-2 py-1 text-xs font-medium rounded-full" [class]="staff.role === 'stylist' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'">
						{{ staff.role | titlecase }}
					</span>
				</td>
				<td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
					{{ staff.working_hours_start }} - {{ staff.working_hours_end }}
				</td>
				<td class="px-6 py-4 whitespace-nowrap">
					<span class="px-2 py-1 text-xs font-medium rounded-full" [class]="staff.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
						{{ staff.is_active ? 'Active' : 'Inactive' }}
					</span>
				</td>
				<td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
					<button (click)="openModal(staff)" class="text-primary hover:text-primary/80">Edit</button>
					<button (click)="deleteStaff(staff)" class="text-red-600 hover:text-red-800">Delete</button>
				</td>
			</tr>
			} @empty {
			<tr>
				<td colspan="6" class="px-6 py-12 text-center text-gray-500">No staff members found</td>
			</tr>
			}
		</tbody>
	</table>
	</div>
</div>
}

<!-- Modal -->
@if (showModal()) {
<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
	<div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
		<div class="flex justify-between items-center px-6 py-4 border-b">
			<h3 class="text-lg font-semibold">{{ isEditMode() ? 'Edit Staff' : 'Add Staff' }}</h3>
			<button (click)="closeModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
		</div>

		<form [formGroup]="staffForm" (ngSubmit)="saveStaff()" class="p-6 space-y-4">
			@if (errorMessage()) {
			<div class="p-3 bg-red-50 text-red-600 rounded text-sm">{{ errorMessage() }}</div>
			}

			<div class="grid grid-cols-2 gap-4">
				<div>
					<label class="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
					<input type="text" formControlName="first_name" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
				</div>
				<div>
					<label class="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
					<input type="text" formControlName="last_name" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
				</div>
			</div>

			<div>
				<label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
				<input type="email" formControlName="email" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
			</div>

			<div>
				<label class="block text-sm font-medium text-gray-700 mb-1">Phone</label>
				<input type="text" formControlName="phone" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
			</div>

			<div>
				<label class="block text-sm font-medium text-gray-700 mb-1">Role *</label>
				<select formControlName="role" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary">
					<option value="stylist">Stylist</option>
					<option value="consultant">Consultant</option>
				</select>
			</div>

			<div class="grid grid-cols-2 gap-4">
				<div>
					<label class="block text-sm font-medium text-gray-700 mb-1">Work Start</label>
					<input type="time" formControlName="working_hours_start" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
				</div>
				<div>
					<label class="block text-sm font-medium text-gray-700 mb-1">Work End</label>
					<input type="time" formControlName="working_hours_end" class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" />
				</div>
			</div>

			<div class="flex items-center">
				<input type="checkbox" formControlName="is_active" id="is_active" class="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" />
				<label for="is_active" class="ml-2 text-sm text-gray-700">Active</label>
			</div>

			<div class="flex justify-end gap-3 pt-4 border-t">
				<button type="button" (click)="closeModal()" class="px-4 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
				<button type="submit" [disabled]="isSubmitting() || staffForm.invalid" class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50">
					{{ isSubmitting() ? 'Saving...' : 'Save' }}
				</button>
			</div>
		</form>
	</div>
</div>
}
